<!-- <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">New message</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <div class="form-group">
            <label for="recipient-name" class="col-form-label">Recipient:</label>
            <input type="text" class="form-control" id="recipient-name">
          </div>
          <div class="form-group">
            <label for="message-text" class="col-form-label">Message:</label>
            <textarea class="form-control" id="message-text"></textarea>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Send message</button>
      </div>
    </div>
  </div>
</div> -->
    <div class="form-group">
      <label for="recipient-name" class="col-form-label">Enter a new value:</label>
      <input type="number"  class="form-control" [ngClass]="data.validation" (ngModelChange)="dataChanged($event)" [(ngModel)]="data.value">
      <small id="passwordHelpBlock" class="form-text text-muted">
        {{data.tooltip}}
      </small>
    </div>
  <div style="float:right;">
    <button type="button" class="btn btn-default" (click)="onNoClick()">Close</button>
    <button type="button" class="btn btn-primary" [mat-dialog-close]="data">Confirm</button>
  </div>
   